import { render, staticRenderFns } from "./CustodianBankIndex.vue?vue&type=template&id=34f3a6c2&"
import script from "./CustodianBankIndex.vue?vue&type=script&lang=js&"
export * from "./CustodianBankIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports